import { render, staticRenderFns } from "./logos.vue?vue&type=template&id=7525ed94&scoped=true"
import script from "./logos.vue?vue&type=script&lang=js"
export * from "./logos.vue?vue&type=script&lang=js"
import style0 from "./logos.vue?vue&type=style&index=0&id=7525ed94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7525ed94",
  null
  
)

export default component.exports